import { Observable } from 'rxjs';

import { ReturnDetailsResponse } from '../../model/return-history.model';

export abstract class ReturnDetailsAdapter {
  abstract loadDetails(
    returnNumber: string
  ): Observable<ReturnDetailsResponse>;
}
